// extracted by mini-css-extract-plugin
module.exports = {"lists":"skills-module--lists--2wHzN","heading":"skills-module--heading--21XGg"};